var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showChatbot)?_c('div',[_c('button',{ref:"button",staticClass:"btn btn-icon btn-outline-primary btn-gradient-outline",on:{"click":_setup.handleChatBotToggle}},[_c('i',{staticClass:"fal fa-sparkles"})]),_c(_setup.ChatBot)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }